<template>
  <form @submit.prevent="submit" class="form-wrapper with-loading" v-form:form novalidate>
    <div class="loading" v-if="isLoading">
      <Loader />
    </div>
    <div class="form-wrapper">
      <div v-if="!showConfirmation" class="form-view">
        <div class="form-row">
          <h2 v-html="$t('view.component.user.remindPassword.formHeader')" class="title"></h2>
          <p v-html="$t('view.component.user.remindPassword.formText')" class="sub-title"></p>
        </div>
        <div class="form-row">
          <div class="input-wrapper">
            <input type="text"
                   ref="email"
                   inputmode="email"
                   v-model="formData.email"
                   autocorrect="off"
                   autocomplete="off"
                   spellcheck="false"
                   required
                   email
                   id="email"
                   name="email" />
            <label for="email">{{ $t('view.component.user.remindPassword.labelEmail') }}</label>
          </div>
          <p class="error-field"
             v-if="isErrorForField('email')"
             v-html="getFieldErrorText('email')">
          </p>
          <p class="error-field"
             v-html="$t('view.component.user.remindPassword.remindPasswordProcessError')"
             v-if="showProcessError">
          </p>

        </div>
        <div class="form-row submit-button-wrapper">
          <button type="submit" class="primary" :class="{disabled: !isFormValid()}">
            {{ $t('view.component.user.remindPassword.buttonSubmit') }}
          </button>
          <p class="register">
            {{ $t('view.component.user.remindPassword.registerText') }}<br>
            <a class="form-link" @click="goToRegister">
              {{ $t('view.component.user.remindPassword.registerLink') }}
            </a>
          </p>
        </div>
      </div>

      <div v-if="showConfirmation" class="resend-view">
        <div class="form-row mb-40">
          <h3 v-html="$t('view.component.user.remindPassword.remindPasswordSuccessHeader')" class="title"></h3>
          <p v-html="$t('view.component.user.remindPassword.remindPasswordSuccessText')" class="sub-title"></p>
        </div>
        <div class="form-row submit-button-wrapper">
          <button type="button" class="primary" @click.prevent="showConfirmation = false">
            {{ $t('view.component.user.remindPassword.remindPasswordSuccessButton') }}
          </button>
          <p>
            {{ $t('view.component.user.remindPassword.registerText') }}<br>
            <a class="form-link" @click="goToRegister">
              {{ $t('view.component.user.remindPassword.registerLink') }}
            </a>
          </p>
        </div>

      </div>
    </div>
  </form>
</template>

<script>
import Loader from '@/orange/components/Loader'
import FormMixin from '@/orange/mixins/form.mixin'
import { mapActions, mapGetters } from 'vuex'
import { ROUTING } from '@/orange/const/routing.const'

export default {
  name: 'UserFormRemindPassword',
  components: { Loader },
  mixins: [FormMixin],
  data () {
    return {
      showConfirmation: false,
      showProcessError: false,
      formData: {
        email: null
      }
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'isUserProcessing'
    })
  },
  methods: {
    ...mapActions([
      'doUserAccountRecoveryGenerateToken'
    ]),
    goToRegister () {
      this.$router.push(ROUTING.user.register)
    },
    submit () {
      this.showProcessError = false
      if (this.form.invalid) {
        return
      }

      this.doUserAccountRecoveryGenerateToken(this.formData)
        .then(() => {
          this.showConfirmation = true
        })
        .catch(() => {
          this.showProcessError = true
        })
    }
  },
  mounted () {
    this.$refs.email.focus()
  }
}
</script>

<style lang="scss" src="../../assets/scss/components/_login-register.scss" scoped></style>
